import React, { useEffect, useState } from 'react'

import 'react-multi-carousel/lib/styles.css'
import { Tab, Tabs } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { ClientForm } from './ClientForm'
import { NoteClient } from './NoteClient'
import { SocialCredentials } from './SocialCredentials'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'
import axiosClient from '../service/axiosClient'
import ClientDTO from '../types/Client'

function ClientsEditPage() {
    const {t} = useTranslation()
    const params = useParams()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const [client, setClient] = useState<ClientDTO | null>(null)

    useEffect(() => {
        if (isNaN(parseInt(params.clientId as string)) || parseInt(params.clientId as string) <= 0) {
            navigate('/app/clients')
        }
    }, [params.clientId])

    // The name is read from the client rather than from the link that opened the page: a sole
    // trader has no company name, so that link carried an empty one and the heading fell back
    // to the client's number.
    useEffect(() => {
        axiosClient.get<ClientDTO>('client/' + params.clientId)
            .then(response => setClient(response.data))
            .catch(() => setClient(null))
    }, [params.clientId])

    const clientName = [client?.companyName, [client?.firstName, client?.lastName]
        .filter(Boolean).join(' ')]
        .map(name => name?.trim())
        .find(name => !!name)

    return (
        <AppLayout>
            <AppTitle append={<Link to={'/app/clients'}>
                <button className="btn amani-primary">{t('back')}</button>
            </Link>}>{clientName || searchParams.get('name') || t('edit_client')}</AppTitle>

            <Tabs
                defaultActiveKey="udaje"
                id="client-form-tabs"
            >
                <Tab eventKey="udaje" title={t('tab_data')}>
                    <ClientForm id={parseInt(params.clientId as string)}/>
                </Tab>
                <Tab eventKey="socials" title={t('tab_social_credentials')}>
                    <SocialCredentials id={parseInt(params.clientId as string)}/>
                </Tab>
                <Tab eventKey="note" title={t('tab_note')}>
                    <NoteClient id={parseInt(params.clientId as string)}/>
                </Tab>

            </Tabs>

        </AppLayout>
    )
}

export default ClientsEditPage
